import { type ReactNode, useEffect } from "react";

interface Props {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    children?: ReactNode;
    footer?: ReactNode;
}

const SidebarSheet = ({ isOpen, onClose, title, children, footer }: Props) => {
    useEffect(() => {
        if (!isOpen) return;

        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === "Escape") {
                onClose();
            }
        };

        document.addEventListener("keydown", handleKeyDown);

        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <div
            className="position-fixed top-0 right-0 bottom-0 left-0"
            style={{ zIndex: 1050 }}
        >
            <div
                className="position-absolute top-0 right-0 bottom-0 left-0 bg-black opacity-50"
                onClick={onClose}
            />
            <aside
                aria-label={title}
                aria-modal="true"
                className="position-absolute top-0 right-0 height-100pct width-100pct max-width-400 bg-white display-flex flex-column shadow-default"
                role="dialog"
            >
                <header className="display-flex align-items-center justify-content-between padding-20 border border-top-none border-right-none border-left-none">
                    <h2 className="margin-0 text-size-20 text-bold text-color-darker">{title}</h2>
                    <button
                        aria-label="Fechar"
                        className="btn btn-muted btn-icon-only"
                        onClick={onClose}
                        type="button"
                    >
                        <span className="rioglyph rioglyph-remove" aria-hidden="true" />
                    </button>
                </header>
                <div className="flex-1-1 padding-20 overflow-y-auto">{children}</div>
                {footer && (
                    <footer className="display-flex justify-content-end gap-10 padding-20 border border-bottom-none border-right-none border-left-none">
                        {footer}
                    </footer>
                )}
            </aside>
        </div>
    );
};

export default SidebarSheet;
